export default __webpack_public_path__ + "static/media/fingerprint.ffb3bdb9.svg";